import React from "react";

const MissionVision = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Our Mission</h1>
      <div className='description'>
        To deliver affordable, personalized and prompt basic healthcare services
        to contractual and project workers in the country.
      </div>
      <h1 className='title'>Our Vision</h1>
      <div className='description'>
        To be the no. 1 Health Maintenance Organization in the Philippines
        providing the highest level of on time quality service delivery mainly
        to contractual and project workers.
      </div>
    </div>
  );
};

export default MissionVision;
